module.exports = __webpack_public_path__ + "static/img/hezuo06.a997ebb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/imgsrc/hezuo06.jpg
// module id = iArr
// module chunks = 1